import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { apiClient } from '../services/api'

export function HomePage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['health'],
    queryFn: async () => {
      const response = await apiClient.get('/Home')
      return response.data
    },
  })

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-xl p-8 md:p-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Welcome to ContractorPro.ai
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Enterprise Contractor Management Platform
            </p>
            
            <div className="grid md:grid-cols-2 gap-6 mt-12">
              <div className="bg-gray-50 rounded-lg p-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  Frontend Status
                </h2>
                <p className="text-green-600 font-medium">✓ Ready</p>
                <p className="text-sm text-gray-500 mt-1">React + Vite + TypeScript</p>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  Backend API Status
                </h2>
                {isLoading && (
                  <p className="text-blue-600 font-medium">Checking...</p>
                )}
                {error && (
                  <p className="text-red-600 font-medium">✗ Offline</p>
                )}
                {data && (
                  <>
                    <p className="text-green-600 font-medium">✓ Connected</p>
                    <p className="text-sm text-gray-500 mt-1">
                      {data.message} (v{data.version})
                    </p>
                  </>
                )}
              </div>
            </div>

            <div className="mt-12 text-center space-x-4">
              <Link
                to="/login"
                className="bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-8 rounded-lg transition duration-200 transform hover:scale-105 inline-block"
              >
                Sign In
              </Link>
              <Link
                to="/register"
                className="bg-white hover:bg-gray-50 text-primary-600 border border-primary-600 font-semibold py-3 px-8 rounded-lg transition duration-200 transform hover:scale-105 inline-block"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}